module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Content Hash Lookup")]), _vm._v(" "), _vm._l((_vm.verdicts), function(verdict, index) {
    return _c('bootstrap-modal', {
      attrs: {
        "title": "Analysis Details",
        "name": 'analysisJson' + index
      }
    }, [_c('json', {
      attrs: {
        "jsonObject": verdict.analysisResult
      }
    })], 1)
  }), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.lookupSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "contentHash"
    }
  }, [_vm._v("Content Hash")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contentHash),
      expression: "contentHash"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "contenthash",
      "placeholder": "Content SHA1 Hash",
      "autofocus": ""
    },
    domProps: {
      "value": _vm._s(_vm.contentHash)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contentHash = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Lookup")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearForm($event)
      }
    }
  }, [_vm._v("Clear")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer10"
  }), _vm._v(" "), (_vm.displayVerdict) ? _c('div', [(_vm.verdicts.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.verdicts), function(verdict, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(verdict.size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatEpoch(verdict.timestamp)))]), _vm._v(" "), _c('td', [_vm._v("WedgeMA™")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.classification))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.virusName || 'N/A'))]), _vm._v(" "), ('analysisResult' in verdict) ? _c('td', [_c('a', {
      attrs: {
        "href": '#analysisJson' + index,
        "data-toggle": "modal"
      }
    }, [_vm._v("show")])]) : _c('td')])
  }))]) : _c('p', [_vm._v("\n        No verdicts found for content hash.\n      ")])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/wedge-logo.png"),
      "width": "200px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Service")]), _vm._v(" "), _c('th', [_vm._v("Classification")]), _vm._v(" "), _c('th', [_vm._v("Virus Name")]), _vm._v(" "), _c('th', [_vm._v("Analysis Result")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5080b747!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HashLookup.vue
// module id = 498
// module chunks = 2